export default __webpack_public_path__ + "static/media/delete.0aa81149.svg";